import React, { useCallback, useEffect, useState } from 'react';
import HourWheel from "../timepicker/components/HourWheel";
import MinuteWheel from "../timepicker/components/MinuteWheel";
import "../timepicker/styles/react-ios-time-picker.css"

// Helper to compare HH:mm strings
const isBeforeMin = (time, minTime) => {
    //console.log(`Comparing time: ${time} with minTime: ${minTime}`);
    const [h, m] = time.split(':').map(Number);
    const [minH, minM] = minTime.split(':').map(Number);
    return h < minH || (h === minH && m < minM);
};


function TimeInputSelection({
   pickerDefaultValue,
   initialValue,
   height,
   setSelectedDate,
   seperator,
   use12Hours,
   onAmPmChange,
   min

}) {
   const initialTimeValue = use12Hours ? initialValue.slice(0, 5) : initialValue;
   const [value, _setValue] = useState(
      initialValue === null ? pickerDefaultValue : initialTimeValue,
   );

    const setValue = useCallback((newValue) => {
        // Handle functional updater
        if (typeof newValue === "function") {
            _setValue(prev => {
                const computed = newValue(prev);
                return min && isBeforeMin(computed, min) ? min : computed;
            });
        } else {
            _setValue(min && isBeforeMin(newValue, min) ? min : newValue);
        }
        //console.log(`Setting value: ${newValue}`);
    }, [min]);

   const [hourFormat, setHourFormat] = useState({
      mount: false,
      hourFormat: initialValue.slice(6, 8),
   });

   useEffect(() => {
      setValue(initialValue === null ? pickerDefaultValue : initialTimeValue);
   }, [initialTimeValue, initialValue, pickerDefaultValue, setValue]);

   useEffect(() => {
      if (hourFormat.mount) {
         onAmPmChange(hourFormat.hourFormat);
      }
   }, [hourFormat, onAmPmChange]);

    useEffect(() => {
        //console.log("value has been changed: " + value);
        setSelectedDate(value);
    }, [setSelectedDate, value]);

   const params = {
      height,
      value,
      setValue,
      use12Hours,
      onAmPmChange,
      setHourFormat,
      hourFormat,
   };


   return (
        <div className="react-ios-time-picker-container" style={{height: `${height * 5 + 40-1}px`}}>
            <div
                className="react-ios-time-picker-selected-overlay"
                style={{
                   top: `${height * 2 + 20}px`,
                   height: `${height}px`,
                }}
            />
            <HourWheel {...params} />
            {seperator && <div className="react-ios-time-picker-colon">:</div>}
            <MinuteWheel {...params} />
         </div>
   );
}

export default TimeInputSelection;
